import React,{useState} from 'react';
import { useParams } from 'react-router-dom';
import { SportList } from '../../../helper/SportActivities';
import styled from 'styled-components'


const SportGalleryPage = () => {
  const { id } = useParams();
  const sport = SportList.find((s) => s.id === parseInt(id));
  const [selectedImage, setSelectedImage] = useState(null);

  if (!sport) return <div>Not Found</div>;

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  return (
    <GalleryWrapper>
      <div className="gallery">
        <h2>{sport.title} </h2>
        <div className="image-grid">
          {sport.images.map((image, index) => (
            <img
              key={index}
              src={`/images/${sport.folderTitle}/${image}`}
              alt={`${sport.title} ${index + 1}`}
              onClick={() => handleImageClick(image)}
            />
          ))}
        </div>
      </div>
      {selectedImage && (
        <Modal onClick={handleCloseModal}>
          <img src={`/images/${sport.folderTitle}/${selectedImage}`} alt={`${sport.title}`} />
        </Modal>
      )}
    </GalleryWrapper>
  );
};


const GalleryWrapper = styled.div`
  .gallery {
    max-width: 1200px;
    margin: 40px auto;
    margin-top:200px;
     h1 {
      text-align: center;
      margin-bottom:10px;
    }
  }
  .image-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .image-grid img {
    width: calc(33.33% - 10px);
    height: auto;
    margin: 5px;
    border-radius: 10px;
    object-fit: cover;
    transition: transform 0.3s ease-in-out;
    cursor: pointer;
    &:hover {
      transform: scale(1.05);
    }
    @media (max-width: 768px) {
      width: calc(50% - 10px);
    }
    @media (max-width: 480px) {
      width: 100%;
    }
  }
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  img {
    max-width: 90%;
    max-height: 90vh;
    object-fit: contain;
    border-radius: 10px;
  }
`;
export default SportGalleryPage;